import { get, post, put } from 'utils/rxfetch'
import { buildURL } from 'utils/urls'

export default () => ({
  getStatus() {
    return get('/members-api/account/status')
  },
  getNotifications(companyId = '') {
    return get(`/members-api/account/notifications/?companyFilter=${companyId}`)
  },
  dismissNotification(body) {
    return post('/members-api/account/notifications/dismiss/', body)
  },
  getOwnerStatus() {
    return get('/members-api/account/owner-status')
  },
  getSbStatus() {
    return get('/members-api/irontraps/scanbackstatus')
  },
  getStats(companyId = '', dateFilter) {
    return get(
      `/members-api/stats?dateFilter=${dateFilter}&license=true&companyFilter=${companyId}`
    )
  },
  sendMitigationReport(companyId = '', body) {
    return post(`/members-api/emailreports/mitigation?companyFilter=${companyId}`, body)
  },
  sendThreatProtectionReport(companyId = '', body) {
    return post(`/members-api/emailreports/threat-protection?companyFilter=${companyId}`, body)
  },
  sendCampaignReport(body, partner) {
    return post(`/members-api/emailreports/campaign?partner=${partner}`, body)
  },
  sendPhishingSimulatorReport(companyId = '', body) {
    return post(`/members-api/emailreports/phishing-simulator?companyFilter=${companyId}`, body)
  },
  shareReportedIncidentsReport(companyId = '', body) {
    return get(
      `/downloads/csv/reported_incidents?companyFilter=${companyId}&shareCSV=true&email=${body.email}&message=${body.message}`
    )
  },
  shareRemediatedEmailsReport(companyId = '', body) {
    return post(`/downloads/csv/remediated_emails?companyFilter=${companyId}`, body)
  },
  sendScanbackReport(companyId = '', body) {
    return post(`/members-api/emailreports/scanback?companyFilter=${companyId}`, body)
  },
  shareAnomaliesReport(companyId = '', body) {
    return post(`/members-api/banner-deep-dive?companyFilter=${companyId}`, {
      ...body,
      share: true,
    })
  },
  shareMailboxesReport(companyId = '', body, queries) {
    return get(
      buildURL('/downloads/csv/profiles', {
        typeFilter: queries.typeFilter,
        tagsFilter: queries.tagsFilter,
        segmentsFilter: queries.segmentsFilter,
        protectedFilter: queries.protectedFilter,
        riskLevelsFilter: queries.riskLevelsFilter,
        shareCSV: true,
        email: body.email,
        message: body.message,
        companyFilter: companyId,
      })
    )
  },
  getStatsList(companyId = '', state, dateFilter, tagsFilter, search) {
    return get(
      `/members-api/stats/list/${state}?dateFilter=${dateFilter}&tagsFilter=${tagsFilter}&search=${search}&companyFilter=${companyId}`
    )
  },
  saveLastSeenProductRelease() {
    return post('/members-api/account/last-seen-product-release')
  },
  dontShowReIntegration(companyId = '') {
    return post(
      `/members-api/account/disable-office-reintegration-popup?companyFilter=${companyId}`
    )
  },
  getActivities(
    companyId = '',
    isCsv,
    sortProperty,
    dateFilter = '',
    eventFilter = '',
    targetsFilter = '',
    createdBy = '',
    page = 1,
    search = '',
    pageSize = 100
  ) {
    const responseType = isCsv ? 'text' : 'json'
    return post(
      buildURL('/members-api/auditevents', {
        csv: isCsv,
        sortProperty,
        page,
        pageSize,
        companyFilter: companyId,
      }),
      {
        search,
        feDateRange: dateFilter,
        query: {
          eventTypes: eventFilter,
          targetTypes: targetsFilter,
          usernameGroups: createdBy,
        },
      },
      {},
      responseType
    )
  },
  getActivitiesFilters(companyId = '') {
    return post(`/members-api/auditevents?companyFilter=${companyId}&getFilterOptions=true`)
  },
  getResources(companyId = '') {
    return get(`/members-api/resources?companyFilter=${companyId}`)
  },
  getSetupSteps(companyId = '') {
    return get(`/members-api/account-setup?companyFilter=${companyId}`)
  },
  dismissStep(companyId = '', body) {
    return put(`/members-api/account-setup/dismiss?companyFilter=${companyId}`, body)
  },
  submitUpsellSeenIndication() {
    return post('/members-api/account/disable-premium-popup')
  },
  getDemoBannerStatus(companyId = '') {
    return get(`/members-api/account/demo-status?companyFilter=${companyId}`)
  },
  /** Persist the user's personal default incident time-frame favorite (not company settings). */
  setDefaultIncidentTimeframe(defaultIncidentDateFilter) {
    return post('/members-api/account/default-incident-timeframe', {
      defaultIncidentDateFilter,
    })
  },
})
